import { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { getLessonPlanDetails } from '../../services/LessonPlansService';
import LessonList from '../../components/training/LessonList';
import TrainingVideo from '../../components/training/TrainingVideo';

export default function LessonPlanDetailPage() {
  const { lessonPlanId } = useParams();
  const [lessonPlan, setLessonPlan] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const location = useLocation();  // ✅ Import useLocation
  const lessonPlanName = location.state?.lessonPlanName;  // ✅ safely grab it

  useEffect(() => {
    async function fetchData() {
      const planDetails = await getLessonPlanDetails(lessonPlanId);
      setLessonPlan(planDetails);

      if (planDetails.length > 0) {
        // ✅ Default to first session's video
        const firstVideo = planDetails[0].training_session_video.training_video;
        setSelectedVideo(firstVideo);
      }
    }
    fetchData();
  }, [lessonPlanId]);

  const handleSessionSelect = (video) => {
    setSelectedVideo(video);
  };

  if (!lessonPlan) return <div>Loading...</div>;

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      {/* Left Side */}
      <div style={{ width: '30%', padding: '20px', borderRight: '1px solid #ccc', overflowY: 'auto' }}>
        <LessonList
          lessonPlanName={lessonPlanName}  // ✅ New prop
          sessions={lessonPlan}
          onSessionSelect={handleSessionSelect}
          selectedVideoId={selectedVideo?.id}
        />
      </div>

      {/* Right Side */}
      <div style={{ flex: 1, padding: '20px' }}>
        {selectedVideo && (
          <TrainingVideo video={selectedVideo} />
        )}
      </div>
    </div>
  );
}
